import { FeatureToggleKey } from "@omni/types/enums/featureToggleKey.enum";

export const FEATURE_TOGGLE_CHANGE_EVENT_NAME = "featuretogglechange";

export class FeatureToggleChangeEvent extends Event {
    private _key: FeatureToggleKey;
    private _enabled: boolean;

    constructor(key: FeatureToggleKey, enabled: boolean) {
        super(FEATURE_TOGGLE_CHANGE_EVENT_NAME);
        this._key = key;
        this._enabled = enabled;
    }

    get key() {
        return this._key;
    }

    get isEnabled() {
        return this._enabled;
    }
}
